export default "__VITE_ASSET__BnVH6yR8__"